import { useState, useEffect } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import apiService from "../../../../../../service/Api";

interface ISPUploadSpeedItem {
  isp: string;
  avg_upload_speed: number;
  venue_count: number;
}

interface ISPUploadSpeedResponse {
  data: ISPUploadSpeedItem[];
  total_isps: number;
  title: string;
}

const ISPPerformanceWidget = () => {
  const [ispLabels, setIspLabels] = useState<string[]>([]);
  const [ispSpeeds, setIspSpeeds] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiService.get<ISPUploadSpeedResponse>(
          "/api/venues/dashboard/isp-vs-upload-speed/"
        );

        const items = response.data?.data ?? [];
        if (!items.length) return;

        // Sort by avg_upload_speed descending (optional)
        items.sort((a, b) => b.avg_upload_speed - a.avg_upload_speed);

        setIspLabels(items.map((item) => item.isp));
        setIspSpeeds(items.map((item) => item.avg_upload_speed));
      } catch (error) {
        console.error("Error fetching ISP performance data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (!ispLabels.length) return <Typography>No data available</Typography>;

  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          ISP Performance (Avg Speed)
        </Typography>

        <BarChart
          layout="horizontal"
          xAxis={[
            {
              label: "Avg Upload Speed (Mbps)",
              scaleType: "linear",
              min: 0,
            },
          ]}
          yAxis={[
            {
              data: ispLabels,
              scaleType: "band",
              width: 180,
            },
          ]}
          series={[
            {
              data: ispSpeeds,
              color: "#6fabddcc",
              label: (value) => `${value}`, // shows speed on each bar
            },
          ]}
          height={350}
        />
      </CardContent>
    </Card>
  );
};

export default ISPPerformanceWidget;
